//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IReadableNumberOptions, readableNumber, readableRate } from '@utils/readableNumber';
import { DECIMAL_CUSTOM_OPTIONS, NUMBER_CUSTOM_OPTIONS } from 'app/constants/highcharts-custom-options';

import { mergeOptions as mergeChartOptions } from '@components/charts/chartHelpers';

function readablePercentageFilter(y: number) {
  const rateOptions: IReadableNumberOptions = {
    rateIncludePercentSuffix: false,
  };
  return readableRate(y, rateOptions);
}

const BASE_CHART_OPTIONS = {
  chart: {
    height: 250,
    width: 900,
  },
};

export const DEFAULT_CHART_OPTIONS = mergeChartOptions(
    BASE_CHART_OPTIONS,
    NUMBER_CUSTOM_OPTIONS(readableNumber),
);

export const PERCENTAGE_CHART_OPTIONS = mergeChartOptions(
    BASE_CHART_OPTIONS,
    DECIMAL_CUSTOM_OPTIONS(readablePercentageFilter),
);
